<template>
  <div>
    <el-row v-if="deviceType == 'Mobile'">
      <el-col :span="24" class="min-w-screen min-h-screen flex items-center justify-center">
        <div>
          <div class="mb-4">
            <h1 class="titillium-web-bold text-xl">Welcome to Intranet</h1>
            <p class="lato-regular text-gray-400 leading-tight text-sm">Please enter your account</p>
          </div>
          <div>
            <el-input class="roboto-mono-200" placeholder="Username" prefix-icon="el-icon-user" v-model="form.username"></el-input>
          </div>
          <div class="mt-1">
            <el-input class="roboto-mono-200" placeholder="Password" prefix-icon="el-icon-lock" v-model="form.password" show-password></el-input>
          </div>
          <div class="mt-1">
            <vue-hcaptcha sitekey="3c5049d3-e571-42d9-9565-73f8c5000c88" @verify="onVerify" @expired="onExpire" @challenge-expired="onChallengeExpire" @error="onError"></vue-hcaptcha>
          </div>
          <div class="mt-2">
            <el-button type="primary" class="roboto-condensed-300 text-base uppercase w-full" :loading="get_loading" @click="login" :disabled="!disabled_login">Login</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="deviceType == 'Desktop'">
      <el-col :span="16" class="relative min-w-screen min-h-screen flex items-center justify-center hero-image">
        <div>
          <el-row>
            <el-col :span="24">
              <div>
                <img src="@/assets/img/logo_lan.png" alt="" class="w-52 p-0 m-0">
              </div>
            </el-col>
          </el-row>
          <div class="absolute inset-x-0 bottom-0">
            <div class="flex justify-center items-center p-0 ml-0 mr-0 mt-0 mb-10">
              <div class="p-0 ml-0 mr-2 my-0">
                <img src="@/assets/img/berakhlak_2.png" alt="" class="w-44 p-0 mx-auto mt-0 mb-0">
              </div>
              <div class="p-0 ml-2 mr-1 my-0">
                <img src="@/assets/img/berakhlak_3.png" alt="" class="w-24 p-0 mx-auto mt-0 mb-0">
              </div>
              <div class="p-0 ml-2 mr-0 my-0">
                <img src="@/assets/img/logo_bsre_new.png" alt="" class="w-44 p-0 mx-auto mt-0 mb-0">
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="min-w-screen min-h-screen flex items-center justify-center">
        <div>
          <div class="mb-4">
            <h1 class="titillium-web-bold text-xl">Welcome to Intranet</h1>
            <p class="lato-regular text-gray-400 leading-tight text-sm">Please enter your account</p>
          </div>
          <div>
            <el-input class="roboto-mono-200" placeholder="Username" prefix-icon="el-icon-user" v-model="form.username"></el-input>
          </div>
          <div class="mt-1">
            <el-input class="roboto-mono-200" placeholder="Password" prefix-icon="el-icon-lock" v-model="form.password" show-password></el-input>
          </div>
          <div class="mt-1">
            <vue-hcaptcha sitekey="3c5049d3-e571-42d9-9565-73f8c5000c88" @verify="onVerify" @expired="onExpire" @challenge-expired="onChallengeExpire" @error="onError"></vue-hcaptcha>
          </div>
          <div class="mt-2">
            <el-button type="primary" class="roboto-condensed-300 text-base uppercase w-full" :loading="get_loading" @click="login" :disabled="!disabled_login">Login</el-button>
          </div>
          <div class="mt-5">
            <p class="font-serif text-gray-500 leading-tight text-xs text-center cursor-pointer" @click="getViews('/privacy-policy-intranet')">Privacy Policy Intranet</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
  props: {
    'deviceType': String
  },
  components: {
    VueHcaptcha
  },
  data() {
    return {
      form: {username: null, password: null},
      verified: false,
      expired: false,
      token: null,
      eKey: null,
      error: null,
    }
  },
  computed: {
    disabled_login() {
      if (this.form.username == null || this.form.password == null || this.form.username == "" || this.form.password == "" || this.verified == false) {
        return false
      }
      return true
    },
    get_loading() {
      return this.$store.state.loading
    }
  },
  async mounted() {
    // Check if user is already logged in and there's a pending SSO request
    const isAuthenticated = this.$store.getters.isAuthenticated;
    const ssoLogin = this.$route.query.sso_login;
    
    if (isAuthenticated && ssoLogin === 'true') {
      // User already logged in, check for pending OAuth
      try {
        const response = await this.$axios.get('/api/sso/authorize/pending');
        
        if (response.data && response.data.data && response.data.data.has_pending === 'true') {
          const params = response.data.data;
          const queryString = new URLSearchParams({
            client_id: params.client_id,
            redirect_uri: params.redirect_uri,
            ...(params.state && { state: params.state })
          }).toString();
          
          // Redirect to complete OAuth flow
          window.location.href = `/api/sso/authorize?${queryString}`;
        }
      } catch (error) {
        console.log('Error checking pending OAuth:', error);
      }
    }
  },
  methods: {
    getViews: function(value) {
      if (this.$route.path !== value) {
        this.$router.push(value);
      }
    },
    login: function() {
      const username = this.form.username;
      const password = this.form.password;
      this.$store.dispatch('login', { username, password })
      .then(async () => {
        // Check if there's a redirect URL (for SSO flow)
        const redirectUrl = this.$route.query.redirect;
        
        if (redirectUrl) {
          // There's a redirect URL, navigate to it (SSO authorize page)
          window.location.href = redirectUrl;
          return;
        }
        
        // No redirect, normal login flow - go to dashboard
        this.$router.push('/dashboard');
        this.form.username = null;
        this.form.password = null;
      })
      .catch(error => {
        console.log(error);
      })
    },
    onVerify(token, ekey) {
      this.verified = true;
      this.token = token;
      this.eKey = ekey;
    },
    onExpire() {
      this.verified = false;
      this.token = null;
      this.eKey = null;
      this.expired = true;
    },
    onChallengeExpire() {
      this.verified = false;
      this.token = null;
      this.eKey = null;
      this.expired = true;
    },
    onError(err) {
      this.token = null;
      this.eKey = null;
      this.error = err;
    }
  },
}
</script>